
export var StatusCheck = function (response) {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response.json());
    } else if (response.status >= 400 && response.status < 500) {
        return Promise.resolve(response.json());
    } else if (response.status >= 500) {
        return Promise.reject(new Error(response.statusText));
    } else {
        return Promise.reject(new Error(response.statusText))
    }
}

export function isNullOrEmpty(o) {
    return (o == undefined || o == null || o.length == 0);
}

export function GetErrorClass(errors, field) {
    let r = null;

    if (!isNullOrEmpty(errors)) {
        if (isNullOrEmpty(field)) field = "";
        for (let i = 0; i < errors.length; i++) {

            if (errors[i].Field == field) {
                // if (errors[i].nature == "e") {
                    r = " validation-error";
                // } else {
                //     r = " validation warning";
                // }
            }

        }
    }

    return r;
}

export function GetErrorFocusElement(errorValidationList, errorOrderedList) {
    for (let iError = 0; iError < errorValidationList.length; iError++) {
        let errorValidation = errorValidationList[iError];

        for (let iErrorOrder = 0; iErrorOrder < errorOrderedList.length; iErrorOrder++) {
            if (errorValidation.Field === errorOrderedList[iErrorOrder].id) {
                errorOrderedList[iErrorOrder].flagged = true;
            }
        }
    }

    for (let iErrorOrder = 0; iErrorOrder < errorOrderedList.length; iErrorOrder++) {
        if (errorOrderedList[iErrorOrder].flagged == true) {
            return errorOrderedList[iErrorOrder].id;
        }
    }
}

export function FormatDate(inputDate, format) {
    if (!inputDate)
        return "";

    let fullDate = new Date(inputDate);
    let monthsAbrv = [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez"
    ];

    let day = fullDate.getDate();
    if (day < 10)
        day = `0${day}`;

    let month = fullDate.getMonth() + 1; // Increment month by 1
    if (month < 10)
        month = `0${month}`;

    let year = fullDate.getFullYear();
    let hour = fullDate.getHours();
    let minutes = fullDate.getMinutes();

    if (minutes < 10)
        minutes = `0${minutes}`;

    switch (format) {
        case "dd/MM/yyyy":
            return `${day}/${month}/${year}`;
        case "dd/MM/yyyy HH:mm":
            return `${day}/${month}/${year} ${hour}:${minutes}`;
        case "yyyy-MM-dd":
            return `${year}-${month}-${day}`;
        case "yyyy-MM-dd HH:mm":
            return `${year}-${month}-${day} ${hour}:${minutes}`;
        case "d MMM yyyy":
            if (month[0] == 0)
                return `${fullDate.getDate()} ${monthsAbrv[month[1] - 1]} ${year}`;
            else
                return `${fullDate.getDate()} ${monthsAbrv[month - 1]} ${year}`;
        default:
            return null;
    }
}

export function toSlug(text) {
    var slug = "";
    // Change to lower case
    var textLower = text.toLowerCase();
    // Letter "e"
    slug = textLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
    // Letter "a"
    slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
    // Letter "o"
    slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
    // Letter "u"
    slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
    // Letter "d"
    slug = slug.replace(/đ/gi, 'd');
    // Trim the last whitespace
    slug = slug.replace(/\s*$/g, '');
    // Change whitespace to "-"
    slug = slug.replace(/\s+/g, '-');

    return slug;
}

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {

        return value;
    }
    if (value == null) {

        return "0";
    }

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});
